import styled from "styled-components";

import { FormDropdownStyledProps as Props } from "./FormDropdown.types";
import { CONSTANTS } from "config/constants";
import { DropdownOverlayStyledProps as OverlayProps } from "./FormDropdown.types";

const { BREAKPOINTS } = CONSTANTS;
const { tablet, mobile } = BREAKPOINTS;

const FormDropdownStyled = styled.div<Props>`
  .FormDropdown {
    &__container {
      background-color: var(--palette-white);
      border-radius: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.4rem;
      border: 0.1rem solid var(--palette-gray-s0-l75);
      cursor: pointer;

      &:hover {
        border: 0.1rem solid var(--palette-black);
      }

      svg path {
        fill: var(--palette-gray-s0-l50);
      }
    }

    &__label {
      color: var(--palette-black);
      font-size: 1.2rem;
      padding-bottom: 0.4rem;
      padding-left: 1rem;
    }

    &__title {
      color: var(--palette-black);
      opacity: 0.4;
      font-size: 1.6rem;
      max-width: 44rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      @media (max-width: ${tablet}px) {
        max-width: 32rem;
      }

      @media (max-width: ${mobile}px) {
        max-width: 20rem;
      }
    }

    &__error {
      color: var(--palette-red-s60-l60);
      font-size: 1.2rem;
      padding-top: 0.4rem;
      padding-left: 1rem;
    }
  }
`;

export const DropdownOverlayStyled = styled.div<OverlayProps>`
  background-color: var(--palette-white) !important;
  padding: 1rem 0rem;
  padding-top: 0;
  border-radius: 1rem;
  max-width: 50.8rem;
  box-shadow: 0rem 0rem 2rem var(--palette-gray-s0-l20-a20);
  margin-top: 1rem;
  max-height: 30rem;
  overflow-y: scroll !important;

  p:nth-child(2) {
    padding-top: 5.2rem;
  }

  @media (max-width: ${tablet}px) {
    width: ${props => props.width + "px"};
    max-width: unset;
    border-bottom-left-radius: unset;
    border-bottom-right-radius: unset;
  }

  .DropdownOverlay {
    &__title {
      color: var(--palette-black);
      font-size: 1.4rem;
      padding: 0.8rem 1.2rem;
      font-weight: 600;
    }

    &__top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 1.6rem;
      gap: 3rem;
      position: fixed;
      background-color: var(--palette-white);
      min-height: 4.8rem;
      border-top-left-radius: 1rem;

      @media (max-width: ${mobile}px) {
        flex-direction: column;
      }
    }

    &__searchBar {
      border-radius: 1rem;
      background-color: var(--palette-primary);
      display: flex;
      align-items: center;
      padding: 1rem 0.6rem;
    }

    &__search {
      border: unset;
      background-color: var(--palette-primary);
      color: var(--palette-white);

      &:focus-visible {
        outline: none;
      }

      &::placeholder {
        color: var(--palette-white);
        font-weight: 600;
      }
    }

    &__searchIcon {
      path {
        fill: var(--palette-white);
      }
    }

    &__text {
      color: var(--palette-black);
      font-size: 1.4rem;
      padding: 0.8rem 2rem;
      cursor: pointer;
      white-space: pre-wrap;
      transition: 0.5s;

      &:hover {
        background-color: var(--palette-gray-s0-l90);
      }

      &:not(:last-child) {
        border-bottom: 0.1rem solid var(--palette-gray-s0-l90);
      }
    }
  }
`;

export default FormDropdownStyled;
